// extracted by mini-css-extract-plugin
export default {"trash":"styles_trash__93kzw"};